(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lumo-languages"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded',()=>{
const forms=[...document.querySelectorAll('.language-form')];
forms.forEach(form=>form.addEventListener('change',()=>{try{localStorage.setItem('lume-language',form.querySelector('select').value);}catch{} form.requestSubmit();}));
const form=forms[0];if(!form)return;
try{
if(sessionStorage.getItem('lume-language-checked'))return;
sessionStorage.setItem('lume-language-checked','1');
if(location.pathname!=='/')return;
const select=form.querySelector('select'),available=[...select.options].map(o=>o.value);
const preferred=localStorage.getItem('lume-language')||(navigator.languages||[navigator.language]).map(l=>l.split('-')[0]).find(l=>available.includes(l))||'en';
if(available.includes(preferred)&&preferred!==select.value){select.value=preferred;form.requestSubmit();}
}catch{}
});
  } catch(e) { console.error(e); }
})();

})();
